// Traduz um Crm::Deal para o formato de conversa que o relatório GERAL já sabe
// ler — mesma ideia do helpers/dealToCard.js no quadro.
//
// O relatório nasceu no modo conversational, onde valor, status e data de
// fechamento vivem em conversation.custom_attributes. Adaptar aqui deixa os
// cálculos, filtros e o mapDeal daquela tela intocados: muda a fonte, não a
// aritmética.
export const dealToReportRow = deal => ({
  id: deal.id,
  is_deal: true,
  deal_id: deal.id,
  // Caixa da conversa de origem (null em negócio criado direto no quadro),
  // para o filtro de caixa valer como no servidor.
  inbox_id: deal.inbox_id ?? null,
  // Campos personalizados da conversa de origem (ex.: marca), pro filtro do
  // cabeçalho valer como no servidor.
  conversation_attributes: deal.conversation_attributes || {},
  // A tela compara com `new Date(c.created_at * 1000)`, que é o formato do
  // payload de conversa (epoch em segundos).
  created_at: deal.created_at
    ? Math.floor(new Date(deal.created_at).getTime() / 1000)
    : null,
  meta: {
    sender: { id: deal.contact?.id, name: deal.contact?.name },
    assignee: deal.assignee_id ? { id: deal.assignee_id } : null,
  },
  custom_attributes: {
    deal_title: deal.title,
    deal_status: deal.status,
    deal_value: deal.value,
    deal_paid_value: deal.paid_value,
    deal_closed_at: deal.closed_at,
    deal_installments_count: deal.installments_count,
    // Origem, forma de pagamento e motivo da perda são id no negócio e texto no
    // modo antigo; quem monta a linha resolve o nome pelas listas do store.
    deal_origin_id: deal.origin_id,
    deal_payment_method_id: deal.payment_method_id,
    deal_lost_reason_id: deal.lost_reason_id,
  },
});
